import React, {ReactNode} from "react";
import {SidebarDashboardPage} from "peggirkit";
import layoutMobileTopBar from "./LayoutMobileTopBar";
import {useIntl} from "react-intl";
import Sidebar from "./menu/Sidebar";
import {Route} from "@/routing/Router";

type Props = {
    currentPage: Route,
    children: ReactNode,
};

const AdminLayout = ({currentPage, children}: Props) => {
    const intl = useIntl();

    return (
        <SidebarDashboardPage
            appName={intl.formatMessage({id: "appName"})}
            title={currentPage.name(intl)}
            mobileBreakpoint={"lg"}
            mobileTopBar={layoutMobileTopBar(intl)}
            sidebar={Sidebar(currentPage)}
            mobileSliderConfig={{
                maxPanelWidth: "max-w-[255px]",
            }}
        >
            {children}
        </SidebarDashboardPage>
    );
};

export default AdminLayout;